export const Settings3 = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.56099 11.7007L15.9986 7.40661L23.4362 11.7007V20.2889L15.9986 24.583L8.56099 20.2889V11.7007ZM15.4986 5.61682C15.808 5.43819 16.1892 5.43819 16.4986 5.61682L24.7362 10.3728C25.0456 10.5514 25.2362 10.8816 25.2362 11.2388V20.7508C25.2362 21.1081 25.0456 21.4382 24.7362 21.6168L16.4986 26.3728C16.1892 26.5514 15.808 26.5514 15.4986 26.3728L7.26099 21.6168C6.95159 21.4382 6.76099 21.1081 6.76099 20.7508V11.2388C6.76099 10.8816 6.95159 10.5514 7.26099 10.3728L15.4986 5.61682ZM13.7892 14.6037L15.8986 13.3859C15.9605 13.3502 16.0367 13.3502 16.0986 13.3859L18.208 14.6037C18.2699 14.6395 18.308 14.7055 18.308 14.777V17.2127C18.308 17.2841 18.2699 17.3502 18.208 17.3859L16.0986 18.6037C16.0367 18.6395 15.9605 18.6395 15.8986 18.6037L13.7892 17.3859C13.7273 17.3502 13.6892 17.2841 13.6892 17.2127V14.777C13.6892 14.7055 13.7273 14.6395 13.7892 14.6037Z"
      fill="currentColor"
    />
  </svg>
)

export const CIOProductsJobTracker = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="8" fill="#F1F2FF" />
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        d="M5.19995 10.3172C5.19995 9.47928 5.87924 8.79999 6.71719 8.79999H21.8896C22.7276 8.79999 23.4068 9.47928 23.4068 10.3172V17.9034C23.4068 18.7414 22.7276 19.4207 21.8896 19.4207H6.71719C5.87924 19.4207 5.19995 18.7414 5.19995 17.9034V10.3172Z"
        fill="url(#paint0_linear_4291_8953)"
      />
    </g>
    <g filter="url(#filter0_b_4291_8953)">
      <path
        d="M8.99377 14.1549C8.99377 13.2924 9.69649 12.5931 10.5633 12.5931H25.6311C26.498 12.5931 27.2007 13.2923 27.2007 14.1549V21.6519C27.2007 22.5145 26.498 23.2138 25.6311 23.2138H10.5633C9.69649 23.2138 8.99377 22.5145 8.99377 21.6519V14.1549Z"
        fill="#96D0AD"
        fillOpacity="0.01"
      />
    </g>
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        d="M8.99377 14.1549C8.99377 13.2924 9.69649 12.5931 10.5633 12.5931H25.6311C26.498 12.5931 27.2007 13.2923 27.2007 14.1549V21.6519C27.2007 22.5145 26.498 23.2138 25.6311 23.2138H10.5633C9.69649 23.2138 8.99377 22.5145 8.99377 21.6519V14.1549Z"
        fill="#9BA1FB"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_4291_8953"
        x="3.99708"
        y="7.59639"
        width="28.2003"
        height="20.6141"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.49835" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4291_8953" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_4291_8953"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4291_8953"
        x1="14.3034"
        y1="8.79999"
        x2="14.3034"
        y2="19.4207"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DBDEFF" />
        <stop offset="1" stopColor="#BBC1FF" />
      </linearGradient>
    </defs>
  </svg>
)

export const CIOProductsPitch = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill="#EAF6FF" />
    <path
      d="M24 15.9992C24 17.9992 23.2 19.2752 23.6 21.1992C24.1501 23.8453 24.8 25.1992 24.4 25.5992C24 25.9992 22.8677 25.228 20.8 24.3992C19.2 23.7579 17.4123 24.7992 15.2 24.7992C10.3399 24.7992 6.40002 20.8593 6.40002 15.9992C6.40002 11.1391 10.3399 7.19922 15.2 7.19922C20.0601 7.19922 24 11.1391 24 15.9992Z"
      fill="url(#paint0_linear_4291_8964)"
    />
    <g filter="url(#filter0_b_4291_8964)">
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 17.7433V17.5672V17.5672C16 16.1244 16.5731 14.7408 17.5933 13.7206C18.6135 12.7004 19.9972 12.1272 21.44 12.1272C22.8828 12.1272 24.2665 12.7004 25.2867 13.7206C26.3069 14.7408 26.88 16.1244 26.88 17.5672V17.5672V17.744C25.2798 18.6695 23.4221 19.1992 21.4406 19.1992C19.4586 19.1992 17.6004 18.6693 16 17.7433ZM24.16 8.31924C24.16 9.82146 22.9422 11.0392 21.44 11.0392C19.9378 11.0392 18.72 9.82146 18.72 8.31924C18.72 6.81703 19.9378 5.59924 21.44 5.59924C22.9422 5.59924 24.16 6.81703 24.16 8.31924Z"
          fill="#111111"
          fillOpacity="0.01"
        />
      </g>
    </g>
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 17.7433V17.5672V17.5672C16 16.1244 16.5731 14.7408 17.5933 13.7206C18.6135 12.7004 19.9972 12.1272 21.44 12.1272C22.8828 12.1272 24.2665 12.7004 25.2867 13.7206C26.3069 14.7408 26.88 16.1244 26.88 17.5672V17.5672V17.744C25.2798 18.6695 23.4221 19.1992 21.4406 19.1992C19.4586 19.1992 17.6004 18.6693 16 17.7433ZM24.16 8.31924C24.16 9.82146 22.9422 11.0392 21.44 11.0392C19.9378 11.0392 18.72 9.82146 18.72 8.31924C18.72 6.81703 19.9378 5.59924 21.44 5.59924C22.9422 5.59924 24.16 6.81703 24.16 8.31924Z"
        fill="#54AFF8"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_4291_8964"
        x="12"
        y="1.59924"
        width="18.88"
        height="21.6"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4291_8964" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_4291_8964"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4291_8964"
        x1="9.20002"
        y1="22.7992"
        x2="21.6"
        y2="12.3992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#96D4FF" />
        <stop offset="1" stopColor="#C3E5FE" />
      </linearGradient>
    </defs>
  </svg>
)

export const CIOProductsInterview = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="8" fill="#E7F4ED" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.373 5.59857C8.18514 5.59828 5.60067 8.18229 5.60038 11.3701L5.59998 15.8029C5.59997 15.8232 5.60029 15.8434 5.60091 15.8635V20.0404C5.60091 20.5547 6.22264 20.8122 6.58626 20.4486L9.30752 17.7273L16.0006 17.7279C19.1884 17.7282 21.7729 15.1442 21.7732 11.9564L21.7732 11.3716C21.7735 8.18375 19.1895 5.59928 16.0017 5.59899L11.373 5.59857Z"
      fill="url(#paint0_linear_4291_8627)"
    />
    <g filter="url(#filter0_b_4291_8627)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0877 10.3151C12.8999 10.3151 10.3157 12.8994 10.3157 16.0872V16.6723C10.3157 19.8602 12.8999 22.4444 16.0877 22.4444H22.4463L24.8472 24.8453C25.4532 25.4513 26.4894 25.0221 26.4894 24.165V18.4013H26.488V16.0872C26.488 12.8994 23.9038 10.3151 20.716 10.3151H16.0877Z"
        fill="#7A81F5"
        fillOpacity="0.01"
      />
    </g>
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0877 10.3146C12.8999 10.3146 10.3157 12.8988 10.3157 16.0866V16.6718C10.3157 19.8596 12.8999 22.4438 16.0877 22.4438H22.4463L25.5041 25.5016C25.8677 25.8652 26.4894 25.6077 26.4894 25.0935V18.4008H26.488V16.0866C26.488 12.8988 23.9038 10.3146 20.716 10.3146H16.0877Z"
        fill="#48BA75"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_4291_8627"
        x="5.50563"
        y="5.50508"
        width="25.7939"
        height="24.4339"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.40502" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4291_8627" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_4291_8627"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4291_8627"
        x1="13.6866"
        y1="5.59857"
        x2="13.6866"
        y2="20.6188"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C6E4D2" />
        <stop offset="1" stopColor="#9BD6B3" />
      </linearGradient>
    </defs>
  </svg>
)

export const Crown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M7.66664 20.1666H24.3333V22.6666H7.66664V20.1666Z" fill="#7A82F5" />
    <path
      d="M7.66664 17.6666L5.99997 10.9999L12.6666 12.6666L16 5.99994L19.3333 12.6666L26 10.9999L24.3333 17.6666H7.66664Z"
      fill="#7A82F5"
    />
  </svg>
)

export const Templates = () => (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5c0-1.1.9-2 2-2h7.6c.5 0 1 .2 1.4.6L25.4 8c.4.4.6.9.6 1.4V21a2 2 0 01-2 2h-3v3a2 2 0 01-2 2H7a2 2 0 01-2-2V10c0-1.1.9-2 2-2h3V5zm0 5H7v16h12v-3h-7a2 2 0 01-2-2V10zm8-5h-6v16h12V11h-3a3 3 0 01-3-3V5zm2 .4V8c0 .6.4 1 1 1h2.6L20 5.4z"
      fill="currentColor"
    />
  </svg>
)

export const Document = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="32" viewBox="0 0 29 32" fill="none">
    <g clipPath="url(#clip0_1435_8217)">
      <path
        d="M2.82399 9.04348L15.1791 0.828613L18.8438 5.55216L20.519 2.47159L21.7755 5.24411L25.0213 5.55216L23.5555 7.5032L23.8696 11.6106L27.5342 16.3342L26.1731 17.361L28.5813 20.647L14.2368 30.9156L1.25342 13.8697L4.18514 11.7133C3.73212 10.8234 3.2784 9.93343 2.82399 9.04348Z"
        fill="transparent"
      />
      <path
        d="M14.5895 27.1892C14.2639 27.1892 14.0733 26.9551 13.9048 26.7148C11.8662 23.7934 9.79299 21.0188 7.7879 18.3367L7.75651 18.2936C5.80063 15.6781 3.77774 12.9724 1.78836 10.1239C1.57895 9.823 1.35383 8.89163 1.72867 8.58358C2.02603 8.34124 2.37888 8.05783 2.74325 7.79906C3.54528 7.22812 5.92102 5.67243 9.80346 3.17819L9.90817 3.10939L13.9225 0.520683C14.1833 0.350224 14.6701 0.0657844 14.9696 0.00725346C15.7475 -0.143695 17.604 2.02606 17.7966 2.77977C17.8521 2.99747 17.8312 3.45442 17.5872 3.70394C17.3715 3.92472 16.9464 3.95758 16.7496 3.90932C16.3307 3.80663 14.8649 2.06097 14.8649 2.06097L3.5568 9.76241L4.19237 10.6024C5.72838 12.7865 7.42145 14.9665 9.05798 17.0716L9.21923 17.277C10.8798 19.4159 13.1205 22.1412 14.6701 24.351L14.7989 24.5338L14.9801 24.4013C16.5779 23.2338 18.651 21.6586 20.3912 20.2939L20.4195 20.2713C22.1021 18.9507 24.0506 17.4813 25.7856 16.2131L25.9489 16.094L25.8379 15.9256C25.7709 15.8229 25.0086 14.7735 24.7992 14.4695C24.6694 14.2806 24.0789 13.4591 24.7071 12.843C25.106 12.4518 25.7887 12.7177 25.8589 12.7886C26.3112 13.2619 26.8567 13.8206 27.5781 14.7242C28.176 15.4738 28.5885 16.5725 27.7791 17.1969C25.8149 18.7146 23.7784 20.3154 21.811 21.8639L21.5827 22.0436C19.6048 23.5983 17.561 25.2053 15.5685 26.7446C15.4359 26.8492 15.2936 26.9413 15.1434 27.0198C14.9748 27.1179 14.7851 27.1759 14.5895 27.1892Z"
        fill="currentColor"
      />
      <path
        d="M16.0406 7.8596C16.3285 7.99823 16.6164 8.15328 16.8949 8.31039C17.1127 8.43053 17.3389 8.55478 17.5682 8.6739C17.6164 8.9758 17.4415 10.0088 17.3588 10.5222C17.3043 10.8447 17.2541 11.124 17.2332 11.3252C17.1557 11.9958 17.4687 12.3408 17.7441 12.5144C17.8479 12.5774 17.9657 12.6148 18.0875 12.6232C18.4247 12.6509 18.8362 12.4918 19.1346 12.2125C19.2393 12.119 19.4047 11.9588 19.5984 11.774C19.9837 11.4084 20.5114 10.9063 20.7093 10.7471C20.8391 10.6477 21.0002 10.5958 21.1648 10.6003C21.2405 10.608 21.3128 10.6353 21.3742 10.6794L21.3931 10.6927L21.414 10.7019C21.6726 10.8282 22.0045 11.088 22.327 11.3386C22.6195 11.583 22.9326 11.8025 23.2631 11.9948C23.3991 12.0673 23.5487 12.112 23.7028 12.1262C24.218 12.1693 24.6253 11.8377 24.6933 11.3201C24.7373 10.9884 24.6452 10.5151 24.5551 10.0622C24.4961 9.80242 24.4555 9.53891 24.4337 9.27359V9.251L24.3918 9.00044C24.219 7.97872 24.2054 7.89554 24.6504 7.46734L24.6588 7.45913C24.7635 7.35028 24.9342 7.1983 25.0943 7.04838C25.4367 6.74032 25.6482 6.54111 25.7435 6.3953C26 6.00407 26.0482 5.60154 25.8786 5.26576C25.7883 5.10102 25.6568 4.96157 25.4963 4.86059C25.3358 4.75962 25.1517 4.70044 24.9614 4.68866C24.7844 4.6712 24.6075 4.65478 24.4305 4.6404C23.907 4.59727 23.3353 4.5603 22.6233 4.52436H22.6024C22.5343 4.5182 22.5291 4.5182 22.4977 4.45351C22.3617 4.20651 22.2418 3.95134 22.1385 3.68953C21.9957 3.31146 21.811 2.9499 21.5878 2.61133L21.5574 2.56409C21.3637 2.26425 21.0695 1.80935 20.5355 1.76519C20.373 1.75359 20.21 1.77889 20.0591 1.83913C19.6466 1.99624 19.4633 2.53842 19.2299 3.22539C19.0267 3.82405 18.7974 4.50075 18.4215 4.83139C18.1597 4.92802 17.889 4.99989 17.6132 5.04601C17.279 5.10329 16.9516 5.19413 16.6363 5.3171L16.5379 5.35715C16.2408 5.46342 15.9564 5.60115 15.6898 5.76789C15.2343 6.0934 15.0197 6.44356 15.0532 6.8081C15.0888 7.20549 15.4197 7.56078 16.0406 7.8596ZM19.6256 5.92911C19.7963 5.76584 20.1356 5.00493 20.4957 3.90825C20.5041 3.93392 21.1889 5.39822 21.2946 5.63748C21.5595 6.23306 23.4316 6.27516 23.7028 6.26797C23.685 6.28645 22.5511 7.32563 22.5354 7.34104C22.127 7.67682 23.017 10.0581 23.0505 10.1546C22.8212 10.0119 21.3208 8.55992 20.9627 8.53014C20.3764 8.48085 20.1555 8.90084 19.7712 9.32801C19.7178 9.38449 18.9514 10.2768 18.9336 10.3046L19.0969 8.40897C19.1764 7.62753 17.5326 6.56679 17.4865 6.55138C18.1263 6.4487 19.3377 6.20328 19.6256 5.92911Z"
        fill="currentColor"
      />
      <path
        d="M15.3885 18.9599C17.3381 17.5932 18.5296 16.9236 19.9442 15.6442C20.2668 15.3603 20.5636 15.0494 20.831 14.7149C21.1933 14.2476 21.2289 13.9961 20.8247 13.5494C20.7034 13.412 20.5534 13.3017 20.385 13.2259C20.2132 13.1483 20.0262 13.1086 19.8371 13.1099C19.648 13.1111 19.4615 13.1532 19.2908 13.2331C19.0999 13.3198 18.9206 13.4291 18.7568 13.5586L17.7632 14.3411C16.6292 15.2314 16.0272 15.7212 14.8974 16.6556C14.4524 17.0243 13.9216 17.4022 13.5509 17.9587C13.2734 18.3756 13.5572 18.7802 13.9289 19.1242C14.132 19.3029 14.8084 19.3645 15.3885 18.9599Z"
        fill="currentColor"
      />
      <path
        d="M14.7391 13.5381C14.9984 13.3167 15.2458 13.0822 15.4804 12.8357C15.7725 12.5205 15.9924 11.6702 15.0218 11.3458C14.603 11.203 14.2365 11.4228 13.9214 11.6179C13.1151 12.1169 12.7874 12.2412 11.7163 12.9815C11.3588 13.239 11.0246 13.5262 10.7174 13.84C10.5482 13.9932 10.4338 14.1958 10.3914 14.4178C10.3489 14.6398 10.3806 14.8693 10.4818 15.0722C10.6137 15.3515 11.3195 15.6801 11.8294 15.4347C11.9885 15.3567 12.1896 15.292 12.377 15.1944C13.4753 14.6194 13.9099 14.2702 14.6805 13.5853L14.7391 13.5381Z"
        fill="currentColor"
      />
      <path
        d="M11.6189 7.84624C11.539 7.8462 11.4593 7.85446 11.3812 7.87089C11.165 7.91277 10.9587 7.99391 10.7729 8.11014L10.4671 8.31552C9.91221 8.68313 9.34052 9.05896 8.80652 9.47587C8.43865 9.78541 8.1103 10.1374 7.8286 10.5243C7.70304 10.6827 7.63305 10.8767 7.62908 11.0773C7.62512 11.2779 7.6874 11.4743 7.80662 11.6374C7.87341 11.7392 7.96026 11.8268 8.06209 11.8951C8.16392 11.9638 8.27845 12.0123 8.39923 12.0379C8.47994 12.056 8.56251 12.065 8.6453 12.0646C8.82632 12.0636 9.00496 12.024 9.16882 11.9485C9.28858 11.8945 9.40286 11.8295 9.51016 11.7545C10.3991 11.1024 11.1771 10.5222 11.889 9.96773C12.1099 9.79299 12.301 9.58504 12.4555 9.35162C12.5514 9.20472 12.6053 9.03526 12.6116 8.86093C12.6178 8.68661 12.5762 8.51385 12.4911 8.3607C12.4059 8.20703 12.2805 8.07838 12.1278 7.98795C11.9746 7.89749 11.7998 7.84826 11.621 7.84521L11.6189 7.84624Z"
        fill="currentColor"
      />
      <path
        d="M14.0515 32C13.8906 31.9999 13.7318 31.9643 13.5868 31.8959C13.4418 31.8275 13.3144 31.7279 13.2139 31.6047C10.701 28.5108 8.52941 25.5822 6.56411 22.8764C4.70979 20.3257 2.79475 17.6887 0.235774 14.5486C0.146314 14.4399 0.0803919 14.3144 0.0420608 14.1799C0.00451434 14.0463 -0.00580789 13.9067 0.0116924 13.7692C0.0303529 13.6311 0.0769949 13.4981 0.148861 13.3779C0.221072 13.2574 0.317624 13.1526 0.432606 13.0699L2.9518 11.2298C3.06467 11.147 3.19314 11.0869 3.3298 11.0531C3.41708 11.0315 3.50674 11.0204 3.59677 11.0203C3.64757 11.02 3.69833 11.0235 3.74861 11.0305C3.88787 11.0486 4.02208 11.0935 4.14348 11.1628C4.26488 11.2321 4.37103 11.3244 4.45578 11.4342C4.54052 11.5441 4.60217 11.6694 4.63715 11.8028C4.67212 11.9362 4.67974 12.0751 4.65954 12.2114C4.63994 12.3469 4.59294 12.4771 4.52132 12.5944C4.44985 12.7143 4.35483 12.819 4.24177 12.9025L2.59896 14.1019L2.73715 14.2744C4.92967 17.0192 6.65206 19.3881 8.31686 21.6791C9.95025 23.9269 11.9177 26.5946 14.1154 29.3435L14.2473 29.5089L27.2673 19.8862C27.4569 19.7418 27.6901 19.6634 27.9301 19.6633C27.9767 19.6634 28.0232 19.6664 28.0694 19.6726C28.2103 19.6906 28.3461 19.7356 28.4693 19.8051C28.592 19.874 28.6993 19.9663 28.7851 20.0765C28.8708 20.1867 28.9333 20.3126 28.9688 20.4468C29.0048 20.5804 29.013 20.7197 28.9929 20.8565C28.9727 20.9932 28.9246 21.1246 28.8515 21.2427C28.7788 21.3629 28.6824 21.4676 28.5678 21.5507L14.7049 31.7967C14.5182 31.9341 14.2912 32.0086 14.0578 32.0093L14.0515 32Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1435_8217">
        <rect width="29" height="32" fill="transparent" />
      </clipPath>
    </defs>
  </svg>
)
